export const SITE = {
  name: "Care for Elektra",
  phone: "0611706945",
  phoneDisplay: "06 11 70 69 45",
  phoneIntl: "+31611706945",
  whatsapp: "31611706945",
  email: "info@careforelektra.nl",
  kvk: "95948627",
  btw: "NL005181420B43",
  region: "Vlaardingen & omstreken (25km)",
  certifications: ["Erkend Installateur", "NEN 3140 Gecertificeerd", "VCA Vol Gecertificeerd"],
  cities: ["Vlaardingen", "Schiedam", "Rotterdam", "Maassluis", "Delft", "Rijswijk"],
  tagline: "Erkend elektricien in Vlaardingen & omstreken",
};

export const IMAGES = {
  heroBg: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/8ox1d4fo_groepenkast.webp",
  serviceFuseBox: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/8ox1d4fo_groepenkast.webp",
  serviceSmartHome: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/001pwx4y_smart%20home.webp",
  serviceEvCharger: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/f4yljqea_laadpaal%202.webp",
  serviceEvChargerDetail: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/f2kykp41_laadpaal.webp",
  serviceAllround: "https://customer-assets.emergentagent.com/job_care-elektra-pro/artifacts/a27h4t4j_allround.webp",
};

export const SERVICES = [
  {
    slug: "groepenkasten",
    icon: "PanelTop",
    title: "Groepenkasten & Meterkasten",
    short: "Upgrade naar 3-fase, uitbreiding en veiligheidscontrole.",
    bullets: [
      "Vernieuwen en uitbreiden van bestaande groepenkasten",
      "Upgrade van 1-fase naar 3-fase voor extra vermogen",
      "Aardlekautomaten en overspanningsbeveiliging",
      "Volledige veiligheidsinspectie en rapportage",
    ],
    image: IMAGES.serviceFuseBox,
  },
  {
    slug: "smart-home",
    icon: "Home",
    title: "Smart Home & Domotica",
    short: "Betrouwbare, onzichtbare modules achter je bestaande schakelaars.",
    bullets: [
      "Slimme modules achter bestaande schakelaars – geen zichtbare wijzigingen",
      "Automatisering van verlichting, gordijnen en apparatuur",
      "Tijdschakelingen, sensoren en scènes op maat",
      "Integratie met Home Assistant, KNX en Zigbee",
    ],
    image: IMAGES.serviceSmartHome,
  },
  {
    slug: "laadpalen",
    icon: "Zap",
    title: "Laadpalen (EV)",
    short: "Professionele installatie van slimme laadpalen zoals Zaptec Go.",
    bullets: [
      "Zaptec Go, Alfen, Wallbox en meer",
      "Dynamic Load Balancing voor veilig verdelen",
      "Nette bekabeling – aan de gevel of ingefreesd",
      "Aanmelding bij netbeheerder en configuratie",
    ],
    image: IMAGES.serviceEvCharger,
  },
  {
    slug: "allround",
    icon: "Wrench",
    title: "Allround Elektrawerk",
    short: "Extra groepen, verplaatsen van stopcontacten en storingzoeken.",
    bullets: [
      "Extra groep voor airco of inductiekookplaat",
      "Stopcontacten en schakelaars verplaatsen of bijplaatsen",
      "Storingen zoeken en oplossen (kortsluiting, aardlek)",
      "Verlichtingsplannen en dimmerinstallatie",
    ],
    image: IMAGES.serviceAllround,
  },
];
